import { render, staticRenderFns } from "./report-history-loader.vue?vue&type=template&id=58a6fe7b"
import script from "./report-history-loader.vue?vue&type=script&lang=js"
export * from "./report-history-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports